import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex--justify-space-between flex--gap-large flex--align-center mb-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Projects ")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "flex flex--justify-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.loading)
          ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode($setup["TabNavigationComponent"], {
                tabs: $setup.filtered_tabs,
                "active-tab": $setup.active_tab,
                disabled: $setup.loading_projects,
                onSetTab: $setup.setTab
              }, null, 8 /* PROPS */, ["tabs", "active-tab", "disabled"]),
              _createVNode($setup["ProjectFiltersComponent"]),
              _createVNode($setup["ProjectGridComponent"], {
                projects: $setup.projects,
                "loading-projects": $setup.loading_projects
              }, null, 8 /* PROPS */, ["projects", "loading-projects"]),
              _createElementVNode("div", _hoisted_4, [
                ($setup.projects.length && $setup.projects.length < $setup.pagination.total_count)
                  ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], {
                      key: 0,
                      ref: "load_more_trigger",
                      small: true
                    }, null, 512 /* NEED_PATCH */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}